define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaPurposeDomain = void 0;
    class WaPurposeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaPurposeDomain.StockOnly, value: "Stock Only" },
                    { key: WaPurposeDomain.StockAndDomestic, value: "Stock and Domestic" },
                    { key: WaPurposeDomain.DomesticOnly, value: "Domestic Only" },
                    { key: WaPurposeDomain.CommunityPurposes, value: "Community Purposes" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaPurposeDomain.StockOnly] = 0;
                this.KeyIndex[WaPurposeDomain.StockAndDomestic] = 1;
                this.KeyIndex[WaPurposeDomain.DomesticOnly] = 2;
                this.KeyIndex[WaPurposeDomain.CommunityPurposes] = 3;
                this.ValueIndex = {};
                this.ValueIndex["Stock Only"] = 0;
                this.ValueIndex["Stock and Domestic"] = 1;
                this.ValueIndex["Domestic Only"] = 2;
                this.ValueIndex["Community Purposes"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaPurposeDomain = WaPurposeDomain;
    Object.defineProperty(WaPurposeDomain, "StockOnly", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaPurposeDomain, "StockAndDomestic", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaPurposeDomain, "DomesticOnly", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(WaPurposeDomain, "CommunityPurposes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(WaPurposeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
